import { ChangeDetectorRef, Component, Inject, TemplateRef, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MaterialService } from "../material.service";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { CdkDragDrop, CdkDropList, DragDropModule, moveItemInArray } from "@angular/cdk/drag-drop";
import { MaterialAttributes, MaterialImageAttributes } from "@albatrosdeveloper/ave-models-package";
import clonedeep from 'lodash.clonedeep';
import { MatSnackBar } from "@angular/material/snack-bar";
import { ICreateImage } from "./interfaces/create-image.interface";
import { ImageService } from "./list-images.service";
import { MediaTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { IUpdateImage } from "./interfaces/update-image.interface";
import { ModalImageComponent } from "app/modules/components/shared/modal-image/modal-image.component";
import { IRequestResult } from "app/common/interfaces";
import { MatMenuModule } from "@angular/material/menu";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { HasPermissionPipe, PermissionDirective, PermissionService } from "app/core/permission";
import { HandlerMessageService } from "app/common/services/handler-error/handler-message.service";
import { MATERIAL_IMAGES_PERMISSIONS } from "app/common/constants/permission";

@Component({
  selector: 'app-list-images.component',
  templateUrl: './list-images.component.html',
  styleUrls: ['./list-images.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIcon,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatSlideToggle,
    PermissionDirective,
    HasPermissionPipe,
  ],
})

export class ListImagesComponent {
  readonly PERMISSIONS_MATERIAL_IMAGES = MATERIAL_IMAGES_PERMISSIONS;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @ViewChild('list1', { static: false }) list1: CdkDropList;
  positionaux = 1
  loadSetPosition = false
  isEditSort = false

  displayedColumns: string[] = [
    'nro',
    'fileName',
    'image',
    //'statusId', //COMENTADO NO IRA EDITAR
    'action'
  ];

  dataSource = new MatTableDataSource<any>([])

  //
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex = 1
  sortActive: keyof MaterialImageAttributes = "position";
  sortDirection: "ASC" | "DESC" = "ASC";

  isLoad = false

  currentCreateImage: ICreateImage = this.initializeCreateImage()
  images: { _id: string, image: File, imageUrl: string }[] = [];
  dialogRefAdd: MatDialogRef<any>;

  currentUpdateImage: IUpdateImage | undefined;

  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;

  // imagen
  file: File;
  imageUrl: string | ArrayBuffer = '';
  fileName: string = "No seleccionó un Archivo";

  isEdit: boolean = false

  constructor(
    private materialService: MaterialService,
    public listImagesService: ImageService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<ListImagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly permissionService: PermissionService,
    private readonly handlerMessage: HandlerMessageService
  ) {
  }

  ngAfterViewInit(): void {
    this.dialogRef.updateSize("90%")
    this.getList()
  }

  async getList(): Promise<void> {
    this.isLoad = true;
    try {
      this.materialService.findOne(this.data._id).subscribe({
        next: (res: IRequestResult<MaterialAttributes>) => {
          this.dataSource.data = res.data.materialImages ?? []
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener materiales.","Cerrar",{ duration: 5000});
        }
      })
    } catch (error) {
      this.snackBar.open(error,"Cerrar",{ duration: 5000});
    } finally {
      this.isLoad = false;
    }
  }

  private initializeCreateImage(): ICreateImage {
    return { 
      name: "",
      image: null
    };
  }

  openCreateModal(): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_MATERIAL_IMAGES.CREATE, "No tienes permisos para crear una imagen")) {
      return;
    }

    this.currentCreateImage = this.initializeCreateImage();
    this.dialogRefAdd = this.dialog.open(this.addModal, { width: "60%", disableClose: true })
    
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openGalleryImages(image: any, type?): void {
    if(this.images.length > 10){
      this.snackBar.open("El límite a agregar es 10 imágenes", "Cerrar", { duration: 3000 });
      return
    }

    const dialogRef = this.dialog.open(ModalImageComponent, {
      width: "500px",
      data: {
        image,
        context: 'material'
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined || result == "Close") {
        return;
      } else {
        this.images.push(result)
      }
    }, error => {
      this.snackBar.open(error.error.message || "Ocurrio un error al subir imagenes.","Cerrar",{ duration: 5000});
    });
  }

  deleteImage(index: number): void {
    this.images.splice(index, 1);
  }

  createImage(): void {
    if(this.images.length == 0){
      this.snackBar.open("Debe agregar al menos una imagen", "Cerrar", { duration: 3000 });
      return
    }

    if(this.images.length > 10){
      this.snackBar.open("El límite a agregar es 10 imágenes", "Cerrar", { duration: 3000 });
      return
    }

    let send = {
      name: this.data.name,
      materialId: this.data._id,
      type: MediaTypeEnum.IMAGE,
    }

    let formD = new FormData()
    for(let key in send){  
      formD.append(key,send[key])
    }
    
    this.images.forEach((imageObj) => {
      formD.append('files', imageObj.image);
    });

    this.materialService.setImage(formD).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.images = []
        if(this.dialogRefAdd){
          this.dialogRefAdd.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  openEditModal(image: MaterialImageAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_MATERIAL_IMAGES.UPDATE, "No tienes permisos para actualizar una imagen")) {
      return;
    }

    this.currentUpdateImage = {
      ...image,
      name: image.image?.name ?? null,
      image: image.image
    };

    this.imageUrl = image.image?.link ?? null
    this.fileName = image.image?.name ?? null

    this.dialog.open(this.editModal, { width: '90%', disableClose: true })
      .afterClosed()
      .subscribe((result) => result);
  }
  
  updateImage(id: string): void {
   if (this.currentUpdateImage) {

      let send = {
        name: this.currentUpdateImage.name,
        materialId: this.data._id,
        imageId: (this.currentUpdateImage as any)._id,
      }

      let formD = new FormData()
      for(let key in send){  
        formD.append(key,send[key])
      }

      if(this.file){
        formD.append('files', this.file)
      }

      this.materialService.updateImage(id, formD).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onChange(file: File) {
    if (file) {
      // Validación de peso del archivo
      /* const fileSize = file.size / 1024;
      if(fileSize > 500) {
        this.snackBar.open('Tamaño máximo de archivo 500 KB', 'Cerrar', { duration: 3000 });
        return
      } */

      // Se reemplaza los espacios por subguión
      var blob = file.slice(0, file.size, file.type);
      let newName = file.name.split('.')[0].replace(/[^a-zA-Z0-9_.-]/g, '_');
      newName = newName.replace('+', '')
      //const fileExtName = extname(file.name);
      const randomName = Array(7).fill(null).map(() => Math.round(Math.random() * 16).toString(16)).join('');
      
      let newFile = new File([blob], `${newName}_${randomName}`, {type: file.type}); //${fileExtName}

      this.fileName = newFile.name;
      this.file = newFile;
      this.currentUpdateImage.image = newFile
      const reader = new FileReader();
      reader.readAsDataURL(newFile);

      reader.onload = event => {
        this.imageUrl = reader.result;
      };
    }
  }

  onStatusChange(event: boolean, image: MaterialImageAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_MATERIAL_IMAGES.UPDATE, "No tienes permisos para actualizar el estado de una imagen")) {
      return;
    }

    const originalStatusId = image.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessImage = { ...image, statusId: updatedStatusId };

    this.materialService.updateStatusImage(updatedBusinessImage).subscribe({
      next: () => {
        this.getList();
      },
      error: () => {
        image.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  openDeleteDialog(materialImage: MaterialImageAttributes): void {
    if (!this.checkIfHasPermission(this.PERMISSIONS_MATERIAL_IMAGES.DELETE, "No tienes permisos para eliminar una imagen")) {
      return;
    }

    this.dialog
      .open(this.deleteDialog, { data: materialImage, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(materialImage._id.toString()));
  }

  delete(id: string): void {
    this.materialService.deleteImage(id, this.data._id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  // ordenamiento
  onListDrop(event: CdkDragDrop<any[]>) {
    // Swap the elements around
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    // updates moved data and table, but not dynamic if more dropzones
    this.dataSource.data = clonedeep(this.dataSource.data);
  }

  setPosition(event) {
    // Swap the elements around
    this.loadSetPosition = true
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    // updates moved data and table, but not dynamic if more dropzones
    this.dataSource.data = clonedeep(this.dataSource.data);
    this.loadSetPosition = false
  }

  onClose(): void {
    this.dialogRef.close({ updated: true }); 
  }


  checkIfHasPermission(permission: string, errorMessage?: string): boolean {
    const hasPermission = this.permissionService.has(permission);

    if (!hasPermission && errorMessage) {
      this.handlerMessage.error({ message: errorMessage });
    }

    return hasPermission;
  }
}
